// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';


var time = "__time(ms)";

exports.time = time;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ../xod-tabtest/src/SpecialColumns.bs.js
// module id = 642
// module chunks = 0